import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { RouteFilter, RouteAddEdit } from './Pages';

export const RouteRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={RouteFilter} />
        <Route exact path = {`${match.path}/AddEdit`} component={RouteAddEdit} />
    </Fragment>
)